import { useId } from "react";
import { cn } from "@/utils";

// Props should extend native Form element
type FormProps = React.ComponentPropsWithoutRef<"form">;

export function FormWrapper(props: FormProps) {
  const id = useId();
  const { children, className, ...rest } = props;

  return (
    <form
      id={id}
      className={cn(
        "max-w-card space-y-4 bg-balder-background-tinted p-6 rounded-lg border border-balder-border-subtle",
        className,
      )}
      {...rest}
      noValidate
    >
      {children}
    </form>
  );
}
